<div>
    <ng-content></ng-content>
</div>
<div class="overlay">
    <h1>Dette indhold er ikke tilgængelig, da det indeholder marketing og statistik cookies, som du har fravalgt i dine indstillinger.</h1>
    <a href="#" (click)="onShowCookieConsent($event)">Opdater dit samtykke</a>
</div>
